import { Routes, Route } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import MenuPage from './pages/MenuPage'
import OrderStatusPage from './pages/OrderStatusPage'
import NotFoundPage from './pages/NotFoundPage'
import { CartProvider } from './cart/CartProvider'

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route
        path="/:slug"
        element={
          <CartProvider>
            <MenuPage />
          </CartProvider>
        }
      />
      <Route
        path="/:slug/order/:orderId"
        element={
          <CartProvider>
            <OrderStatusPage />
          </CartProvider>
        }
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
